module.exports = __webpack_public_path__ + "img/iconOrange.ddcf61ef.png";